/**
 * Component added to the collider boxes along the help lines
 */
class HelpLinesBoxColliderComponent {
    constructor() {
        this.typeId = HelpLinesBoxColliderComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
HelpLinesBoxColliderComponent.id = 2050;
export default HelpLinesBoxColliderComponent;
//# sourceMappingURL=HelpLinesBoxColliderComponent.js.map